import {
  E_FORM_GENERATION_ERROR,
  E_FORM_GENERATION_REQUEST,
  E_FORM_GENERATION_SUCCESS,
  E_FORM_GENERATION_RESET,
  EFORM_DOWNLOAD_ERROR,
  EFORM_DOWNLOAD_REQUEST,
  EFORM_DOWNLOAD_SUCCESS
} from './actionTypes';
import { EFormGenerationReq } from './models/types';

export const getEFormGenerationStatus = {
  request: (): EFormGenerationReq => ({
    type: E_FORM_GENERATION_REQUEST,
  }),
  success: (data) => ({ type: E_FORM_GENERATION_SUCCESS, data }),
  failure: (error) => ({ type: E_FORM_GENERATION_ERROR, error })
};

export const eFormGenrationResetState = {
  request: () => ({
    type: E_FORM_GENERATION_RESET
  })
};

export const eFormDownload = {
  request: (payload,callback: React.ReactNode | null = () => null) => ({
    type: EFORM_DOWNLOAD_REQUEST,
    payload,
    callback
  }),
  success: (data) => ({ type: EFORM_DOWNLOAD_SUCCESS, data }),
  failure: (error) => ({ type: EFORM_DOWNLOAD_ERROR, error })
}